import { graphql } from '../graphql/graphql';
import { buttonFragment } from './buttonFragment';
import { textFragment } from './textFragment';
import { weblinkFragment } from './weblinkFragment';

export const dynamicContentFragment = graphql(
  `
    fragment DynamicContent on DynamicContent {
      ... on Text {
        __typename
        ...Text
      }
      ... on WebLink {
        __typename
        ...WebLink
      }
      ... on Button {
        __typename
        ...Button
      }
    }
  `,
  [textFragment, weblinkFragment, buttonFragment],
);
